module.exports = __webpack_public_path__ + "img/a3.9cd2e9c1.jpg";